import React, { memo, useEffect } from 'react';
import { Flex } from '@smarterservices/smarter-ui';
import SessionDetails from '../SessionDetails';
import { useAppStore } from '../../stores/StoreContext';
import { useSecondPaneContext } from '../Common/SplitView/SplitViewContext';

const SessionDetailsWrapper = memo(({ sessionDetailsRef }) => {
    const { hidePane, showPane } = useSecondPaneContext();
    const sessionDetailsEnabled = useAppStore((state) => state.enabledComponents?.sessionDetails || false);

    // Hide/show pane and divider based on sessionDetailsEnabled
    useEffect(() => {

        if (!sessionDetailsEnabled) {
            hidePane(); // Hides second pane + divider, expands first pane to 100%
            if (sessionDetailsRef) {
                sessionDetailsRef.current = null;
            }
        } else {
            showPane(); // Shows second pane + divider, restores layout
        }
    }, [sessionDetailsEnabled, hidePane, showPane, sessionDetailsRef]);

    if (!sessionDetailsEnabled) {
        return null;
    }
    return (
        <Flex.Item
            as="div"
            overflowX="hidden"
            shouldShrink
            shouldGrow
            height="100%"
            elementRef={(el) => {
                if (sessionDetailsRef) {
                    sessionDetailsRef.current = el;
                }
            }}
        >
            <SessionDetails />
        </Flex.Item>
    );
});

SessionDetailsWrapper.displayName = 'SessionDetailsWrapper';

export default SessionDetailsWrapper;
